module.exports = __webpack_public_path__ + "6f14f260d94deeeee92b49600f0bdec5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/info.svg
// module id = 759
// module chunks = 0